import Vue from 'vue'

import App from './App.vue'
import './registerServiceWorker'
import router from './router/index.js'
import store from './store'
import axios, { initializeInterceptor } from './plugins/axios-interceptor' // Use axios with interceptors
import VueAxios from 'vue-axios'
import DashboardPlugin from './plugins/dashboard-plugin';
import { permissionMixin } from './mixins/permissionMixin.js'
import { setupPermissionGuard } from './router/permissionGuard';

Vue.use(DashboardPlugin);

// Initialize axios interceptor with router and store after they are created
initializeInterceptor(router, store);

import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)


Vue.use(require('vue-shortkey'))

import datePicker from 'vue-bootstrap-datetimepicker';
Vue.use(datePicker); // Register datePicker

Vue.use(VueAxios, axios)

// Initialize tenant from domain and configure axios baseURL
// This must happen before Vue instance is created
store.dispatch('server/initializeTenant');

// Set backend domain prototype for legacy compatibility
Vue.prototype.$backDomain = store.getters['server/baseURL'];

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = "Bearer "+token
}

import VueExcelEditor from 'vue-excel-editor'
Vue.use(VueExcelEditor)

import vSelect from 'vue-select'
Vue.component('vu-select', vSelect)
import "vue-select/dist/vue-select.css";
// Apply the mixin globally
Vue.mixin(permissionMixin);

// Setup the router guard
setupPermissionGuard(router, store);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
